import React, { useEffect, useState } from "react";


import {
  Chart as ChartJS,
  TimeScale,
  LinearScale,
  CategoryScale,
  BarElement,
  LineElement,
  PointElement,
  LineController, // ✅ ADD THIS
  BarController, // ✅ You can add this too for full clarity
  Tooltip,
  Legend,
  Title,
} from "chart.js";



import "chartjs-adapter-moment";
import { Chart } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "antd";
import moment from "moment";
import chartAction from "../../../redux/transactions/actions";
import "./index.scss";

ChartJS.register(
  CategoryScale,
  LinearScale,
  TimeScale,
  BarElement,
  BarController, // ✅
  LineElement,
  LineController, // ✅
  PointElement,
  Tooltip,
  Legend,
  Title
);
const { Option } = Select;
const { getDailyChartData } = chartAction;

const ComboChart = () => {
  const dispatch = useDispatch();
  const { dailyChartData } = useSelector((state) => state.transactionReducer);
  const { agentId } = useSelector((state) => state.authReducer);

  const [selectedOption, setSelectedOption] = useState("daily");
  const [chartData, setChartData] = useState({ datasets: [] });

  useEffect(() => {
    if (!agentId) {
      dispatch(getDailyChartData());
    } else {
      dispatch(getDailyChartData(agentId));
    }
  }, [dispatch, agentId]);

  useEffect(() => {
    const rawData = dailyChartData?.data?.[selectedOption];
    if (!rawData) return;

    const currentHour = moment().hour();

    const filteredData =
      selectedOption === "daily"
        ? rawData.filter((entry) => {
            const [, endTime] = entry?.time?.split("-") || [];
            return moment(endTime, "HH:mm").hour() <= currentHour;
          })
        : rawData;

    const processedData = filteredData;

    const labels = processedData.map((entry) => {
      return selectedOption === "daily"
        ? moment(entry?.time?.split("-")[0], "HH:mm").toDate()
        : selectedOption === "fiveYears" || selectedOption === "allData"
        ? moment(entry?.time, "YYYY").toDate()
        : moment(entry?.time).toDate();
    });

    const successAmountData = processedData.map(
      (entry) => (entry?.data?.successAmount || 0) / 100
    );
    const failedAmountData = processedData.map(
      (entry) => (entry?.data?.failureAmount || 0) / 100
    );
    const successTransactions = processedData.map(
      (entry) => entry?.data?.successTransactions || 0
    );
    const failedTransactions = processedData.map(
      (entry) => entry?.data?.failedTransactions || 0
    );

    // ✅ Dynamic bar size config
    const { barPercentage, categoryPercentage } =
      selectedOption === "threeMonths"
        ? { barPercentage: 0.6, categoryPercentage: 0.6 }
        : { barPercentage: 0.9, categoryPercentage: 0.8 };

    setChartData({
      labels,
      datasets: [
      
        {
          type: "bar",
          label: "Success Transactions",
          data: labels.map((time, i) => ({
            x: time,
            y: successTransactions[i],
          })),
          backgroundColor: "#49a5cb",
          yAxisID: "y",
          barPercentage,
          categoryPercentage,
        },
        {
          type: "bar",
          label: "Failed Transactions",
          data: labels.map((time, i) => ({
            x: time,
            y: failedTransactions[i],
          })),
          backgroundColor: "#f79a14",
          yAxisID: "y",
          barPercentage,
          categoryPercentage,
        },
          {
          type: "bar",
          label: "Success Amount",
          data: labels.map((time, i) => ({ x: time, y: successAmountData[i] })),
           borderColor: "#569757", // 🔵 Blue
      backgroundColor: "#569757",
      
      barPercentage,
          categoryPercentage,
          yAxisID: "y1",
        },
        {
          type: "bar",
          label: "Failed Amount",
          data: labels.map((time, i) => ({ x: time, y: failedAmountData[i] })),
          borderColor: "F44336", // 🟠 Orange
      backgroundColor: "#F44336",
          tension: 0.4,
          yAxisID: "y1",
           barPercentage,
          categoryPercentage,
        },
      ],
    });
  }, [dailyChartData, selectedOption]);

  // ✅ Dynamic bar width depending on the selected time range

  const getTimeUnitForSelectedOption = (option) => {
    switch (option) {
      case "daily":
        return "hour";
      case "weekly":
        return "day";
      case "threeMonths":
      case "sixMonths":
      case "oneYear":
        return "month";
      case "fiveYears":
      case "allData":
        return "year";
      default:
        return "day";
    }
  };

  const formatTickLabel = (value) => {
    const date = moment(value);
    switch (selectedOption) {
      case "daily":
        return date.format("h A");
      case "weekly":
        return date.format("D MMM");
      case "threeMonths":
      case "sixMonths":
      case "oneYear":
        return date.format("MMM YYYY");
      case "fiveYears":
      case "allData":
        return date.format("YYYY");
      default:
        return date.format("D MMM");
    }
  };

  const chartOptions = {
  
    responsive: true,
    layout: {
      padding: {
        top: 10,
        bottom: 10,
        left: 15,
        right: 15,
      },
    },
    plugins: {
      title: {
        display: true,
        text: "Success & Failed Transactions with Amounts",
      },
      legend: {
        position: "top",
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      x: {
        type: "time",
        time: {
          unit: getTimeUnitForSelectedOption(selectedOption),
        },
        ticks: {
          callback: (value) => formatTickLabel(value),
        },
      },
      y: {
        type: "time",
        time: {
          unit: getTimeUnitForSelectedOption(selectedOption),
        },
        ticks: {
          callback: (value) => formatTickLabel(value),
        },
      },
      y: {
        beginAtZero: true,
        position: "left",
        title: {
          display: true,
          text: "Transactions",
           padding: { 
        left: 20,  // ✅ Increase left padding to create more space
        right: 10, // Optional: Adjust right padding if needed
      },
      font: {
        size: 18,  // Optional: Adjust font size if needed
        weight: 'bold',
      }
        },
      },
      y1: {
        beginAtZero: true,
        position: "right",
        grid: {
          drawOnChartArea: false,
        },
        title: {
          display: true,
          text: "Amount (₹)",
           padding: { 
        left: 23,  // ✅ Increase left padding to create more space
        right: 10, // Optional: Adjust right padding if needed
      },
      font: {
        size: 18,  // Optional: Adjust font size if needed
        weight: 'bold',
      }
        },
      },
    },
  };

  return (
    <div>
      <div className="headingGrpah">
        <h4> Transaction Analytics</h4>
        <div className="d-flex gap-1">
          <Select
            value={selectedOption}
            onChange={(val) => setSelectedOption(val)}
            style={{ width: 180 }}
          >
            <Option value="allData">All Data</Option>
            <Option value="daily">Daily</Option>
            <Option value="oneWeek">One Week</Option>
            <Option value="oneMonth">One Month</Option>
            <Option value="threeMonths">3 Months</Option>
            <Option value="sixMonths">6 Months</Option>
            <Option value="oneYear">One Year</Option>
            <Option value="fiveYears">5 Years</Option>
          </Select>
        </div>
      </div>
      <div className="cssGraph" style={{ width: "100%", maxWidth: "100%" }}>
        <Chart
          type="bar"
          data={chartData}
          options={chartOptions}
          height={130}
        />
      </div>
    </div>
  );
};

export default ComboChart;
